import { escapeRegExp } from '../regex';
/**
 * `fuzzyFilter` constructs regular expressions on the fly to fuzzily match a single
 * value from an object against a search string.
 */
export function fuzzyFilter(query, key, list) {
    if (list.length < 1)
        return list;
    var validatedQuery = escapeRegExp(query);
    var parsed = validatedQuery
        .split(' ')
        .map(function (word) { return "(?=.*" + word + ")"; })
        .join('');
    var re = new RegExp(parsed, 'i');
    return list.filter(function (item) { return re.test(String(item[key])); });
}
//# sourceMappingURL=fuzzyFilter.js.map